// Mobile menu toggle functionality
document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.querySelector('[data-mobile-menu-toggle]')
  const closeButton = document.querySelector('[data-mobile-menu-close]')
  const mobileMenu = document.getElementById('mobile-menu')

  if (!toggleButton || !closeButton || !mobileMenu) return

  const openMenu = () => {
    mobileMenu.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  const closeMenu = () => {
    mobileMenu.classList.add('hidden')
    document.body.style.overflow = ''
  }

  toggleButton.addEventListener('click', openMenu)
  closeButton.addEventListener('click', closeMenu)

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !mobileMenu.classList.contains('hidden')) {
      closeMenu()
    }
  })

  // Close when clicking a link inside the mobile menu
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu)
  })
})
